import { ZOrderButtons } from './ZOrderButtons';
import { isLogoElement, useTextEditorStore } from './useTextEditorStore';

import { Slider } from '@/components/ui/slider';
import { TooltipProvider } from '@/components/ui/tooltip';

interface LogoPropertyBarProps {
  elementId: string;
}

export function LogoPropertyBar({ elementId }: LogoPropertyBarProps) {
  const element = useTextEditorStore((s) => s.elements.find((el) => el.id === elementId));
  const updateElement = useTextEditorStore((s) => s.updateElement);

  if (!element || !isLogoElement(element)) return null;

  const opacityPct = Math.round(element.opacity * 100);

  const VARIANT_LABELS: Record<'primary' | 'light' | 'dark', string> = {
    primary: 'Primary',
    light: 'Light',
    dark: 'Dark',
  };

  return (
    <div className="flex h-10 items-center gap-4 px-4">
      <div className="flex items-center gap-2">
        <span className="shrink-0 text-detail text-muted-foreground">Opacity</span>
        <Slider
          value={[opacityPct]}
          min={0}
          max={100}
          step={1}
          className="w-24"
          onValueChange={([v]) =>
            updateElement(elementId, { opacity: v / 100 }, { skipHistory: true })
          }
          onValueCommit={([v]) => updateElement(elementId, { opacity: v / 100 })}
        />
        <span className="w-8 shrink-0 text-right text-detail tabular-nums text-muted-foreground">
          {opacityPct}%
        </span>
      </div>

      <span className="inline-flex items-center rounded-full border border-border/50 bg-muted/40 px-2 py-0.5 text-detail font-medium text-muted-foreground">
        {VARIANT_LABELS[element.logoVariant]} logo
      </span>

      <TooltipProvider delayDuration={300}>
        <ZOrderButtons elementId={elementId} />
      </TooltipProvider>

      <span className="ml-auto hidden text-detail text-muted-foreground/60 md:inline">
        &#8984;D duplicate &middot; arrow keys nudge &middot; &#9003; delete
      </span>
    </div>
  );
}
